import React, { useEffect, useState } from "react";
import Button from "@mui/material/Button";
import { connect } from "react-redux";
import { setDialedNumberInc } from "../../redux/actions/actions";
import voice from "../../assets/assets/images/voice.png";
import { toast } from "react-toastify";
import axios from "axios";
import {
  BaseUrl,
  VoiceDomainName,
  VoiceDomainNamePure
} from "../../container/BaseUrl/BaseUrl";
import { IconButton, Pagination, Skeleton, Stack } from "@mui/material";
import { RiErrorWarningLine } from "react-icons/ri";
import moment from "moment";
import { Swap } from "@phosphor-icons/react";

const mapStateToProps = (state) => {
  return { skillset: state.data.skillset };
};

const AgentContact = (props) => {
  const agent = JSON.parse(localStorage.getItem("tokenAgent"));
  const [pagination, setPagination] = useState(0);
  const [page, setPage] = useState(1);
  const [pagination2, setPagination2] = useState(0);
  const [page2, setPage2] = useState(1);
  const [pagination3, setPagination3] = useState(0);
  const [page3, setPage3] = useState(1);
  const [pagination4, setPagination4] = useState(0);
  const [page4, setPage4] = useState(1);

  const [buttontype1, setbuttontype1] = useState("contained");
  const [buttontype2, setbuttontype2] = useState("outlined");
  const [buttontype3, setbuttontype3] = useState("outlined");
  const [buttontype4, setButtontype4] = useState("outlined");
  const [serviceReportList, setServiceReportList] = useState([]);
  const [salesReport, setSalesReport] = useState([]);
  const [smsReport, setSmsReport] = useState([]);
  const [loadingAgentService, setLoadingAgentService] = useState(false);
  const [loadingAgentSales, setLoadingAgentSales] = useState(false);
  const [loadingAgentreport, setLoadingAgentreport] = useState(false);
  const [loadingSmsCount, setLoadingSmsCount] = useState(false);
  const [tableListType, settableListType] = useState("table1");
  const [agentCount, setagentCount] = useState([]);

  const ServiceReport = async () => {
    setLoadingAgentService(true);
    await axios
      .post(
        BaseUrl + "/contact/listAgentservicereport",
        {
          offset: page == 1 ? 0 : (page - 1) * 10,
          limit: 10,
          agent_id: agent.agent_id,
        },
        {
          headers: {
            Authorization: "Bearer " + localStorage.getItem("access_token"),
            "Content-Type": "application/json",
            tenantId: localStorage.getItem("TenantId"),
          },
        }
      )
      .then((res) => {
        if (res.data.status) {
          setServiceReportList(res.data.data);
          setPagination(res.data.count);
          setTimeout(() => {
            setLoadingAgentService(false);
          }, 1000);
        } else {
          toast.warn("No Data Found", {
            position: "top-right",
            autoClose: 500,
            hideProgressBar: true,
            closeOnClick: false,
            pauseOnHover: false,
            draggable: false,
            progress: undefined,
            theme: "light",
          });
          setServiceReportList([]);
          setTimeout(() => {
            setLoadingAgentService(false);
          }, 1000);
        }
      })
      .catch((error) => {
        console.log("AgentContact", error);
        setTimeout(() => {
          setLoadingAgentSales(false);
        }, 1000);
      });
  };
  const SalesReport = async () => {
    setLoadingAgentSales(true);
    await axios
      .post(
        BaseUrl + "/contact/listAgentreport",
        {
          offset: page2 == 1 ? 0 : (page2 - 1) * 10,
          limit: 10,
          agent_id: agent.agent_id,
        },
        {
          headers: {
            Authorization: "Bearer " + localStorage.getItem("access_token"),
            "Content-Type": "application/json",
            tenantId: localStorage.getItem("TenantId"),
          },
        }
      )
      .then((res) => {
        if (res.data.status) {
          setSalesReport(res.data.data);
          setPagination2(res.data.count);
          setTimeout(() => {
            setLoadingAgentSales(false);
          }, 1000);
        } else {
          toast.warn("No Data Found", {
            position: "top-right",
            autoClose: 500,
            hideProgressBar: true,
            closeOnClick: false,
            pauseOnHover: false,
            draggable: false,
            progress: undefined,
            theme: "light",
          });
          setSalesReport([]);
          setTimeout(() => {
            setLoadingAgentSales(false);
          }, 1000);
        }
      })
      .catch((error) => {
        console.log("AgentContact", error);
        setTimeout(() => {
          setLoadingAgentSales(false);
        }, 1000);
      });
  };
  const smsCountReportAgent = () => {
    setLoadingSmsCount(true);
    let body = {
      agent_id: agent.agent_id,
      offset: page == 1 ? 0 : (page - 1) * 10,
      limit: 10,
    };
    axios
      .post(BaseUrl + "/contact/smssendcount", body, {
        headers: {
          Authorization: "Bearer " + localStorage.getItem("access_token"),
          "Content-Type": "application/json",
          tenantId: localStorage.getItem("TenantId"),
        },
      })
      .then((res) => {
        if (res.data.success == true) {
          setSmsReport(res.data.Data);
          setPagination4(res.data.count);
          setTimeout(() => {
            setLoadingSmsCount(false);
          }, 1000);
        } else {
          toast.warn("No Data Found", {
            position: "top-right",
            autoClose: 1000,
            hideProgressBar: false,
            closeOnClick: true,
            pauseOnHover: true,
            draggable: true,
            progress: undefined,
            theme: "light",
          });
          setPagination4(0);
          setTimeout(() => {
            setLoadingSmsCount(false);
          }, 1000);
        }
      });
  };
  const agentCallcount = async () => {
    setLoadingAgentreport(true);
    let body = {
      offset: page3 == 1 ? 0 : (page3 - 1) * 10,
      limit: 10,
      agent_id: agent.agent_id,
    };
    await axios
      .post(BaseUrl + "/contact/callcontactcount", body, {
        headers: {
          Authorization: "Bearer " + localStorage.getItem("access_token"),
          "Content-Type": "application/json",
          tenantId: localStorage.getItem("TenantId"),
        },
      })
      .then((res) => {
        console.log("agentCallcount", res.data.Data);
        if (res.data.success == true) {
          setagentCount(res.data.Data);
          setPagination3(res.data.count);
          setTimeout(() => {
            setLoadingAgentreport(false);
          }, 1000);
        } else {
          setagentCount([]);
          setPagination3(0);
          setTimeout(() => {
            setLoadingAgentreport(false);
          }, 1000);
        }
      })
      .catch((error) => {
        console.log("error", error);
      });
  };
  const makeCall = (calledNo, type, id, reg_no) => {
    let number =localStorage.getItem("TenantId")=='788205e1-6116-4c09-904a-5b641d09de0f'?`${calledNo}`:`9${calledNo}`;
    if (
      localStorage.getItem("statusValue") == "Ready" ||
      localStorage.getItem("statusValue") == "Not Ready"
    ) {
      localStorage.setItem("callActivate", "true");
      localStorage.setItem("CallMadeFromDcc", "true");
      let agentLoginTerminalId = localStorage.getItem("agentLoginTerminalId");
      let avcurlid = localStorage.getItem("AvcUrl");
      props.setDialedNumberInc(number);
      localStorage.setItem("ClickeToCallPhoneNum", number);
      localStorage.setItem("dailedNumber", number);
      localStorage.setItem("ClickToCall", "true");
      axios
        .post(
          avcurlid +
            `/voice/terminal/${agentLoginTerminalId}/createContact/sip:${agentLoginTerminalId}@${localStorage.getItem("TenantId")=='788205e1-6116-4c09-904a-5b641d09de0f'?VoiceDomainNamePure:VoiceDomainName}/sip:${number}@${localStorage.getItem("TenantId")=='788205e1-6116-4c09-904a-5b641d09de0f'?VoiceDomainNamePure:VoiceDomainName}`,
          {},
          {
            headers: {
              ssoToken: localStorage.getItem("ssoToken"),
            },
          }
        )
        .then((res) => {
          if (res.data.status == "OK") {
            localStorage.setItem("type", type);
            localStorage.setItem("ContactVoiceId", id);
            localStorage.setItem("Contactreg_no", reg_no);
            // localStorage.setItem("ClickToCall", "true");
          } else {
            toast.warn(res.data.status, {
              position: "top-right",
              autoClose: 500,
              hideProgressBar: true,
              closeOnClick: false,
              pauseOnHover: false,
              draggable: false,
              progress: undefined,
              theme: "light",
            });
          }
        })
        .catch((err) => {
          console.log("makeCall", err.code == " ERR_BAD_REQUEST");
          if (err.code == "ERR_BAD_REQUEST") {
            toast.error("Please change status to Ready", {
              position: "top-right",
              autoClose: 500,
              hideProgressBar: true,
              closeOnClick: false,
              pauseOnHover: false,
              draggable: false,
              progress: undefined,
              theme: "light",
            });
          }
        });
    } else {
      toast.error("Please change status to Ready", {
        position: "top-right",
        autoClose: 500,
        hideProgressBar: true,
        closeOnClick: false,
        pauseOnHover: false,
        draggable: false,
        progress: undefined,
        theme: "light",
      });
    }
  };
  const takeSurvey = async (item, type) => {
    let body = {
      phonenumber: item.Mobile ? item.Mobile : item.MOBILE,
      skillset: "customer service",
      channel: "voice",
      type: type,
      reg_no: item.Registration_No ? item.Registration_No : item.REG_NO,
      contact_id: item.id,
    };
    await axios
      .post(BaseUrl + "/ticket/crmscreenpop", body, {
        headers: {
          Authorization: "Bearer " + localStorage.getItem("access_token"),
          "Content-Type": "application/json",
          tenantId: localStorage.getItem("TenantId"),
        },
      })
      .then((res) => {
        window.open(res.data.data);
        toast.success("screen pop url generated", {
          position: "top-right",
          autoClose: 500,
          hideProgressBar: true,
          closeOnClick: false,
          pauseOnHover: false,
          draggable: false,
          progress: undefined,
          theme: "light",
        });
      })
      .catch((error) => {
        toast.warning("screen pop url not generated", {
          position: "top-right",
          autoClose: 500,
          hideProgressBar: true,
          closeOnClick: false,
          pauseOnHover: false,
          draggable: false,
          progress: undefined,
          theme: "light",
        });
      });
  };

  const handleChange = (event, value) => {
    setPage(value);
    ServiceReport();
  };
  const handleChange2 = (event, value) => {
    setPage2(value);
    SalesReport();
  };
  const handleChange3 = (event, value) => {
    setPage3(value);
    agentCallcount();
  };
  const handleChange4 = (event, value) => {
    setPage4(value);
    smsCountReportAgent();
  };

  useEffect(() => {
    handleChange;
  }, []);

  return (
    <div className="sessiontable">
      <nav class="navbar navbar-expand-lg navbar-light bg-light">
        <div class="w-100">
          <div className="d-flex align-item-center justify-content-between align-items-center">
            <Stack className="d-flex flex-row gap-1">
              <Button
                size="small"
                id="primary-btn"
                variant={buttontype1}
                onClick={() => {
                  setbuttontype1("contained");
                  setbuttontype2("outlined");
                  setbuttontype3("outlined");
                  setButtontype4("outlined");

                  ServiceReport();
                  settableListType("table1");
                  localStorage.setItem("surveyType", "Service");
                }}
              >
                Service
              </Button>
              <Button
                size="small"
                id="primary-btn"
                variant={buttontype2}
                onClick={() => {
                  setbuttontype1("outlined");
                  setbuttontype2("contained");
                  setbuttontype3("outlined");
                  setButtontype4("outlined");

                  settableListType("table2");

                  localStorage.setItem("surveyType", "Sales");
                  SalesReport();
                }}
              >
                Sales
              </Button>

              <Button
                size="small"
                id="agent-primary-btn"
                variant={buttontype3}
                onClick={() => {
                  setbuttontype1("outlined");
                  setbuttontype2("outlined");
                  setbuttontype3("contained");
                  setButtontype4("outlined");

                  agentCallcount();
                  settableListType("table3");

                  localStorage.setItem("surveyType", "AgentReport");
                }}
              >
                Agent Report
              </Button>
              <Button
                size="small"
                id="agent-primary-btn"
                variant={buttontype4}
                onClick={() => {
                  setbuttontype1("outlined");
                  setbuttontype2("outlined");
                  setbuttontype3("outlined");
                  setButtontype4("contained");
                  settableListType("table4");

                  localStorage.setItem("surveyType", "smsCount");
                  smsCountReportAgent();
                }}
              >
                SMS count
              </Button>
            </Stack>
          </div>
        </div>
      </nav>

      <div className="container-fluid  p-2">
        <div className="card fixed-table-card vh-79 ">
          {(() => {
            switch (tableListType) {
              case "table1":
                return (
                  <>
                    <div class="card-body agentContactbody">
                      <div class="table-responsive vhm-68">
                        <table
                          className="table table-sm table-hover align-middle table-fixeded"
                          style={{ width: "160%" }}
                        >
                          <thead>
                            <tr>
                              <th scope="col">Action</th>
                              <th scope="col">Customer Name</th>
                              <th scope="col">Mobile</th>
                              <th scope="col">Registration No</th>
                              <th scope="col">Model Description</th>
                              <th scope="col">Call Status</th>
                              <th scope="col">Count</th>
                              <th scope="col">Chassis No</th>
                              <th scope="col">Job Card</th>
                              <th scope="col">Email</th>
                              <th scope="col">Address2</th>
                              <th scope="col">Brand</th>
                              <th scope="col">Location</th>

                              <th scope="col">Invoice No</th>
                              <th scope="col">Invoice Date</th>
                              <th scope="col">Year</th>
                              <th scope="col">External Color</th>
                              <th scope="col">Customer Category</th>
                              <th scope="col">Service Advisor</th>
                              <th scope="col">Mileage</th>
                              <th scope="col">Date</th>
                              <th scope="col">Timestamp</th>
                              <th scope="col">Action</th>
                            </tr>
                          </thead>
                          <tbody>
                            {loadingAgentService ? (
                              [...Array(10)].map((_, rowIndex) => (
                                <tr key={rowIndex}>
                                  {[...Array(18)].map((_, colIndex) => (
                                    <td key={colIndex}>
                                      <Skeleton
                                        variant="text"
                                        width={100}
                                        height={30}
                                      />
                                    </td>
                                  ))}
                                </tr>
                              ))
                            ) : serviceReportList.length > 0 ? (
                              serviceReportList.map((rowData, rowIndex) => (
                                <tr
                                  key={rowIndex.id}
                                  className="text-break"
                                  id="service-btn"
                                >
                                  <td>
                                    <img
                                      className="icons-size"
                                      src={voice}
                                      alt="webchat"
                                      onClick={() => {
                                        makeCall(
                                          rowData.MOBILE,
                                          "service",
                                          rowData.id,
                                          rowData.REG_NO
                                        );
                                      }}
                                    />
                                  </td>
                                  <td>{rowData.CUST_NAME}</td>
                                  <td>{rowData.MOBILE}</td>
                                  <td>{rowData.REG_NO}</td>
                                  <td>{rowData.Model_Description}</td>
                                  <td>{rowData.callstatus}</td>
                                  <td>{rowData.count}</td>
                                  <td>{rowData.CHASSIS_NO}</td>
                                  <td>{rowData.Job_Card}</td>
                                  <td>{rowData.EMAIL}</td>
                                  <td>{rowData.Address2}</td>
                                  <td>{rowData.Brand}</td>
                                  <td>{rowData.Location}</td>

                                  <td>{rowData.Invoice_No}</td>
                                  <td>{rowData.Invoice_Date}</td>
                                  <td>{rowData.YEAR}</td>
                                  <td>{rowData.External_Color}</td>
                                  <td>{rowData.CUSTOMER_CATEGORY}</td>
                                  <td>{rowData.ADVISOR}</td>
                                  <td>{rowData.MILEAGE}</td>
                                  <td>
                                    {moment(rowData.createdAt).format("L")}
                                  </td>
                                  <td>
                                    {moment(rowData.createdAt).format(
                                      "hh:mm A"
                                    )}
                                  </td>
                                  <td>
                                    <IconButton
                                      onClick={() => {
                                        takeSurvey(rowData, "service");
                                      }}
                                    >
                                      <Swap size={22} weight="bold" />
                                    </IconButton>
                                  </td>
                                </tr>
                              ))
                            ) : (
                              <tr key="">
                                <td colSpan="15">
                                  <div
                                    className="text-muted"
                                    style={{
                                      flexDirection: "column",
                                      marginTop: "20%",
                                      display: "flex",
                                      position: "absolute",
                                      left: "45%",
                                      bottom: "40%",
                                    }}
                                  >
                                    <span className="mx-auto">
                                      <RiErrorWarningLine size={30} />
                                    </span>
                                    <span className="mx-auto">
                                      <h5
                                        className="text-muted mt-2"
                                        style={{ fontFamily: "poppins" }}
                                      >
                                        No Data Found
                                      </h5>
                                    </span>
                                  </div>
                                </td>
                              </tr>
                            )}
                          </tbody>
                        </table>
                      </div>
                    </div>

                    <div className="card-footer rounded-0 d-flex justify-content-between">
                      <div>
                        Showing {Math.min((page - 1) * 10 + 1, pagination)} to{" "}
                        {Math.min(page * 10, pagination)} of {pagination}{" "}
                        entries
                      </div>
                      <Pagination
                        count={Math.ceil(pagination / 10)}
                        page={page}
                        color="primary"
                        size="small"
                        style={{ float: "right" }}
                        onChange={handleChange}
                      />
                    </div>
                  </>
                );
              case "table2":
                return (
                  <>
                    <div class="card-body agentContactbody">
                      <div class="table-responsive vhm-68">
                        <table
                          className="table table-sm table-hover align-middle table-fixeded"
                          style={{ width: "140%" }}
                        >
                          <thead>
                            <tr>
                              <th scope="col">Action</th>
                              <th scope="col">Customer Name</th>
                              <th scope="col">Mobile</th>
                              <th scope="col">Registration No</th>
                              <th scope="col">Model Description</th>
                              <th scope="col">Call Status</th>
                              <th scope="col">Count</th>
                              <th scope="col">Chassis No</th>
                              <th scope="col">Email</th>
                              <th scope="col">Address2</th>
                              <th scope="col">Brand</th>
                              <th scope="col">Location</th>
                              <th scope="col">Invoice Branch</th>
                              <th scope="col">Invoice No</th>
                              <th scope="col">Invoice Date</th>
                              <th scope="col">Year</th>
                              <th scope="col">External Color</th>
                              <th scope="col">Customer Category</th>
                              <th scope="col">Salesman</th>
                              <th scope="col">Delivary Date</th>
                              <th scope="col">Date</th>
                              <th scope="col">Timestamp</th>
                              <th scope="col">Action</th>
                            </tr>
                          </thead>
                          <tbody>
                            {loadingAgentSales ? (
                              [...Array(10)].map((_, rowIndex) => (
                                <tr key={rowIndex}>
                                  {[...Array(23)].map((_, colIndex) => (
                                    <td key={colIndex}>
                                      <Skeleton
                                        variant="text"
                                        width={80}
                                        height={30}
                                      />
                                    </td>
                                  ))}
                                </tr>
                              ))
                            ) : salesReport.length > 0 ? (
                              salesReport.map((rowData, rowIndex) => (
                                <tr
                                  key={rowIndex.id}
                                  className="text-break"
                                  id="sales-btn"
                                >
                                  <td>
                                    <img
                                      className="icons-size"
                                      src={voice}
                                      alt="webchat"
                                      onClick={() => {
                                        makeCall(
                                          rowData.Mobile,
                                          "sales",
                                          rowData.id,
                                          rowData.Registration_No
                                        );
                                      }}
                                    />
                                  </td>
                                  <td>{rowData.Customer_Name}</td>
                                  <td>{rowData.Mobile}</td>
                                  <td>{rowData.Registration_No}</td>
                                  <td>{rowData.Model_Description}</td>
                                  <td>{rowData.callstatus}</td>
                                  <td>{rowData.count}</td>
                                  <td>{rowData.Chassis_No}</td>
                                  <td>{rowData.Email}</td>
                                  <td>{rowData.Address2}</td>
                                  <td>{rowData.Brand}</td>
                                  <td>{rowData.Location}</td>
                                  <td>{rowData.Inv_Brch}</td>
                                  <td>{rowData.Invoice_No}</td>
                                  <td>{rowData.Inv_Date}</td>
                                  <td>{rowData.Year}</td>
                                  <td>{rowData.External_Color}</td>
                                  <td>{rowData.Customer_Category}</td>
                                  <td>{rowData.Salesman}</td>
                                  <td>{rowData.Delivery_Date}</td>
                                  <td>
                                    {moment(rowData.createdAt).format("L")}
                                  </td>
                                  <td>
                                    {moment(rowData.createdAt).format(
                                      "hh:mm A"
                                    )}
                                  </td>
                                  <td>
                                    <IconButton
                                      onClick={() => {
                                        takeSurvey(rowData, "sales");
                                      }}
                                    >
                                      <Swap size={22} weight="bold" />
                                    </IconButton>
                                  </td>
                                </tr>
                              ))
                            ) : (
                              <tr key="">
                                <td colSpan="15">
                                  <div
                                    className="text-muted"
                                    style={{
                                      flexDirection: "column",
                                      marginTop: "20%",
                                      display: "flex",
                                      position: "absolute",
                                      left: "45%",
                                      bottom: "40%",
                                    }}
                                  >
                                    <span className="mx-auto">
                                      <RiErrorWarningLine size={30} />
                                    </span>
                                    <span className="mx-auto">
                                      <h5
                                        className="text-muted mt-2"
                                        style={{ fontFamily: "poppins" }}
                                      >
                                        No Data Found
                                      </h5>
                                    </span>
                                  </div>
                                </td>
                              </tr>
                            )}
                          </tbody>
                        </table>
                      </div>
                    </div>

                    <div className="card-footer rounded-0 d-flex justify-content-between">
                      <div>
                        Showing {Math.min((page2 - 1) * 10 + 1, pagination2)} to{" "}
                        {Math.min(page2 * 10, pagination2)} of {pagination2}{" "}
                        entries
                      </div>
                      <Pagination
                        count={Math.ceil(pagination2 / 10)}
                        page={page2}
                        color="primary"
                        size="small"
                        style={{ float: "right" }}
                        onChange={handleChange2}
                      />
                    </div>
                  </>
                );
              case "table3":
                return (
                  <>
                    <div class="card-body agentContactbody">
                      <div class="table-responsive vhm-68">
                        <table
                          className="table table-sm table-hover align-middle table-fixeded"
                          style={{ width: "130%" }}
                        >
                          <thead>
                            <tr className="">
                              <th scope="col" style={{ width: "30%" }}>
                                Total Assign Call
                              </th>
                              <th scope="col" style={{ width: "30%" }}>
                                Total Pending Call
                              </th>
                              <th scope="col" style={{ width: "30%" }}>
                                Total Complete Call
                              </th>
                            </tr>
                          </thead>
                          <tbody>
                            {loadingAgentreport ? (
                              [...Array(3)].map((_, rowIndex) => (
                                <tr key={rowIndex}>
                                  {[...Array(3)].map((_, colIndex) => (
                                    <td key={colIndex}>
                                      <Skeleton
                                        variant="text"
                                        width={50}
                                        height={30}
                                      />
                                    </td>
                                  ))}
                                </tr>
                              ))
                            ) : agentCount.length > 0 ? (
                              agentCount.map((rowData, rowIndex) => (
                                <tr key={rowIndex.id} className="" id="">
                                  <td>{rowData.total}</td>
                                  <td>{rowData.totalpendingcall}</td>
                                  <td>{rowData.totalcompletecall}</td>
                                </tr>
                              ))
                            ) : (
                              <tr key="">
                                <td colSpan="15">
                                  <div
                                    className="text-muted"
                                    style={{
                                      flexDirection: "column",
                                      marginTop: "20%",
                                      display: "flex",
                                      position: "absolute",
                                      left: "45%",
                                      bottom: "40%",
                                    }}
                                  >
                                    <span className="mx-auto">
                                      <RiErrorWarningLine size={30} />
                                    </span>
                                    <span className="mx-auto">
                                      <h5
                                        className="text-muted mt-2"
                                        style={{ fontFamily: "poppins" }}
                                      >
                                        No Data Found
                                      </h5>
                                    </span>
                                  </div>
                                </td>
                              </tr>
                            )}
                          </tbody>
                        </table>
                      </div>
                    </div>

                    <div className="card-footer rounded-0 d-flex justify-content-between">
                      <div>
                        Showing {Math.min((page3 - 1) * 10 + 1, pagination3)} to{" "}
                        {Math.min(page3 * 10, pagination3)} of {pagination3}{" "}
                        entries
                      </div>

                      <Pagination
                        count={Math.ceil(pagination3 / 10)}
                        page={page3}
                        color="primary"
                        size="small"
                        style={{ float: "right" }}
                        onChange={handleChange3}
                      />
                    </div>
                  </>
                );
              case "table4":
                return (
                  <>
                    <div className="card-body agentContactbody">
                      <div className="table-responsive vhm-68">
                        <table
                          className="table table-sm table-hover align-middle table-fixeded"
                          style={{ width: "100%" }}
                        >
                          <thead>
                            <tr className="">
                              <th scope="col" style={{ width: "30%" }}>
                                Agent Name
                              </th>
                              <th scope="col" style={{ width: "30%" }}>
                                Total Assign Call
                              </th>
                              <th scope="col" style={{ width: "30%" }}>
                                Total Pending Call
                              </th>
                              <th scope="col" style={{ width: "30%" }}>
                                Total Complete Call
                              </th>
                            </tr>
                          </thead>
                          <tbody>
                            {loadingSmsCount ? (
                              [...Array(3)].map((_, rowIndex) => (
                                <tr key={rowIndex}>
                                  {[...Array(3)].map((_, colIndex) => (
                                    <td key={colIndex}>
                                      <Skeleton
                                        variant="text"
                                        width={50}
                                        height={30}
                                      />
                                    </td>
                                  ))}
                                </tr>
                              ))
                            ) : smsReport.length > 0 ? (
                              smsReport.map((rowData, rowIndex) => (
                                <tr key={rowIndex.id} className="" id="">
                                  <td>
                                    {rowData.users.username == null ||
                                    rowData.users.username == undefined ||
                                    rowData.users.username == ""
                                      ? "--"
                                      : rowData.users.username}
                                  </td>
                                  <td>{rowData.total}</td>
                                  <td>{rowData.totalpendingcall}</td>
                                  <td>{rowData.totalcompletecall}</td>
                                </tr>
                              ))
                            ) : (
                              <tr key="">
                                <td colSpan="15">
                                  <div
                                    className="text-muted"
                                    style={{
                                      flexDirection: "column",
                                      marginTop: "20%",
                                      display: "flex",
                                      position: "absolute",
                                      left: "45%",
                                      bottom: "40%",
                                    }}
                                  >
                                    <span className="mx-auto">
                                      <RiErrorWarningLine size={30} />
                                    </span>
                                    <span className="mx-auto">
                                      <h5
                                        className="text-muted mt-2"
                                        style={{ fontFamily: "poppins" }}
                                      >
                                        No Data Found
                                      </h5>
                                    </span>
                                  </div>
                                </td>
                              </tr>
                            )}
                          </tbody>
                        </table>
                      </div>
                    </div>

                    <div className="card-footer rounded-0 d-flex align-item-center justify-content-end align-items-center">
                      <Pagination
                        count={Math.ceil(pagination4 / 10)}
                        page={page4}
                        color="primary"
                        size="small"
                        style={{ float: "right" }}
                        onChange={handleChange4}
                      />
                    </div>
                  </>
                );
              default:
                return (
                  <>
                    <div class="card-body agentContactbody">
                      <div class="table-responsive vhm-68">
                        <table
                          className="table table-sm table-hover align-middle table-fixeded"
                          style={{ width: "160%" }}
                        >
                          <thead>
                            <tr>
                              <th scope="col">Action</th>
                              <th scope="col">Customer Name</th>
                              <th scope="col">Mobile</th>
                              <th scope="col">Registration No</th>
                              <th scope="col">Model Description</th>
                              <th scope="col">Call Status</th>
                              <th scope="col">Count</th>
                              <th scope="col">Chassis No</th>
                              <th scope="col">Job Card</th>
                              <th scope="col">Email</th>
                              <th scope="col">Address2</th>
                              <th scope="col">Brand</th>
                              <th scope="col">Location</th>

                              <th scope="col">Invoice No</th>
                              <th scope="col">Invoice Date</th>
                              <th scope="col">Year</th>
                              <th scope="col">External Color</th>
                              <th scope="col">Customer Category</th>
                              <th scope="col">Service Advisor</th>
                              <th scope="col">Mileage</th>
                              <th scope="col">Date</th>
                              <th scope="col">Timestamp</th>
                              <th scope="col">Action</th>
                            </tr>
                          </thead>
                          <tbody>
                            {loadingAgentService ? (
                              [...Array(10)].map((_, rowIndex) => (
                                <tr key={rowIndex}>
                                  {[...Array(18)].map((_, colIndex) => (
                                    <td key={colIndex}>
                                      <Skeleton
                                        variant="text"
                                        width={100}
                                        height={30}
                                      />
                                    </td>
                                  ))}
                                </tr>
                              ))
                            ) : serviceReportList.length > 0 ? (
                              serviceReportList.map((rowData, rowIndex) => (
                                <tr
                                  key={rowIndex.id}
                                  className="text-break"
                                  id="service-btn"
                                >
                                  <td>
                                    <img
                                      className="icons-size"
                                      src={voice}
                                      alt="webchat"
                                      onClick={() => {
                                        makeCall(
                                          rowData.MOBILE,
                                          "service",
                                          rowData.id,
                                          rowData.REG_NO
                                        );
                                      }}
                                    />
                                  </td>
                                  <td>{rowData.CUST_NAME}</td>
                                  <td>{rowData.MOBILE}</td>
                                  <td>{rowData.REG_NO}</td>
                                  <td>{rowData.Model_Description}</td>
                                  <td>{rowData.callstatus}</td>
                                  <td>{rowData.count}</td>
                                  <td>{rowData.CHASSIS_NO}</td>
                                  <td>{rowData.Job_Card}</td>
                                  <td>{rowData.EMAIL}</td>
                                  <td>{rowData.Address2}</td>
                                  <td>{rowData.Brand}</td>
                                  <td>{rowData.Location}</td>

                                  <td>{rowData.Invoice_No}</td>
                                  <td>{rowData.Invoice_Date}</td>
                                  <td>{rowData.YEAR}</td>
                                  <td>{rowData.External_Color}</td>
                                  <td>{rowData.CUSTOMER_CATEGORY}</td>
                                  <td>{rowData.ADVISOR}</td>
                                  <td>{rowData.MILEAGE}</td>
                                  <td>
                                    {moment(rowData.createdAt).format("L")}
                                  </td>
                                  <td>
                                    {moment(rowData.createdAt).format(
                                      "hh:mm A"
                                    )}
                                  </td>
                                  <td>
                                    <IconButton
                                      onClick={() => {
                                        takeSurvey(rowData, "service");
                                      }}
                                    >
                                      <Swap size={22} weight="bold" />
                                    </IconButton>
                                  </td>
                                </tr>
                              ))
                            ) : (
                              <tr key="">
                                <td colSpan="15">
                                  <div
                                    className="text-muted"
                                    style={{
                                      flexDirection: "column",
                                      marginTop: "20%",
                                      display: "flex",
                                      position: "absolute",
                                      left: "45%",
                                      bottom: "40%",
                                    }}
                                  >
                                    <span className="mx-auto">
                                      <RiErrorWarningLine size={30} />
                                    </span>
                                    <span className="mx-auto">
                                      <h5
                                        className="text-muted mt-2"
                                        style={{ fontFamily: "poppins" }}
                                      >
                                        No Data Found
                                      </h5>
                                    </span>
                                  </div>
                                </td>
                              </tr>
                            )}
                          </tbody>
                        </table>
                      </div>
                    </div>

                    <div className="card-footer rounded-0 d-flex justify-content-between">
                      <div>
                        Showing {Math.min((page - 1) * 10 + 1, pagination)} to{" "}
                        {Math.min(page * 10, pagination)} of {pagination}{" "}
                        entries
                      </div>
                      <Pagination
                        count={Math.ceil(pagination / 10)}
                        page={page}
                        color="primary"
                        size="small"
                        style={{ float: "right" }}
                        onChange={handleChange}
                      />
                    </div>
                  </>
                );
            }
          })()}
        </div>
      </div>
    </div>
  );
};

export default connect(mapStateToProps, { setDialedNumberInc })(AgentContact);
